import { randomId } from '@shared/utils';

const buildOptimisticMutationMeta = ({ meta = null } = {}) => {
  const currentMeta = meta && typeof meta === 'object' && !Array.isArray(meta) ? meta : {};
  const requestId = String(currentMeta?.requestId || randomId() || '').trim();
  const localChangeAtValue = Number(currentMeta?.localChangeAt);
  const localChangeAt = Number.isFinite(localChangeAtValue) && localChangeAtValue > 0 ? localChangeAtValue : Date.now();

  return {
    ...currentMeta,
    requestId,
    localChangeAt
  };
};

export default buildOptimisticMutationMeta;
